export enum CARDTYPE {
    VIRTUAL_CARD = 0,
    PHYSICAL_CARD = 1
} 

export enum CARDSTATUS {
    INACTIVE = 0,
    ACTIVE = 1,
    TEMPBLK = 2,
    PERMBLK = 3,
    DORMANT = 4,
    CLOSED = 5,
    CMPLNCEBLK = 6,
    BLKLIST = 7
} 

export const WALLETCARDRETVAL = {
    SUCCESS: 1,
    ACCOUNT_EXISTS: 5400,
    INVALID_DATA_LENGTH: 5900,
    INVALID_PIN: 209,
    CARD_LOCKED: 208,
    CARD_PINATTEMPTS_EXCEEDED: 818,
    WALLET_LOCKED: 114,
    PIN_SAME_AS_PREVIOUS: 814,
    CARD_NOT_ACTIVE: 817,
    SYSTEM_ERROR: 826
}

export const CARDCONTROLTYPE = {
    INTERNATIONAL: 1,
    DOMESTIC: 2,
}

export const CARDCHANNELTYPE = {
    ATM: 1,
    ECOM: 2,
    INSTORE: 3,
    CONTACTLESSPAYMENT: 4
}

export const CARDLIMITFREQUENCYTYPE = {
    DAILY: 1,
    MONTHLY:2
}

export const CARDACTIONTYPE = {
    SHOWDETAILS: "ShowDetails",
    HOME: "Home",
    LOCKORUNLOCKCARD: "LockOrUnlockCard"
}

export const CARDREPLACEREASONTYPE = {
    LOST: "Lost",
    STOLEN: "Stolen",
    DAMAGED: "Damaged",
    EXPIRED: "Expired"
}

export enum WALLETCARDTYPE {
    VIRTUAL = 0,
    DIGITALCARD = 0,
    WALLET = 0,
    PHYSICAL = 1
}

export enum PHYSICAlCARDPREFERENCE {
    IN_PERSON = "In-person",
    IN_MAIL = "In The Mail"
}

export enum WALLETCARDACTIONTYPE{
    VIRTUAL_CARD_APPLY = "virtual Card Apply",
    PHYSICAL_CARD_APPLY = "physicalCard Apply",
    PHYSICAL_CARD_PIN_SET = "physical Card Pin Set",
    PHYSICAL_CARD_CVV_SET = "physical Card Cvv Set",
    PHYSICAL_CARD_PIN_CONFRIM_SET = "physical Card Pin Confrim Set",
    PYSICAL_CARD_PIN_CHANGE = "physical card pin change"
}

export enum WALLETCARDPINTYPE{
    CARDPIN_SETUP = "Create Card Pin",
    CARDPIN_CHANGE = "Reset Card Pin"
}

export enum WALLETTRANSACTIONPERPAGE {
    HOME = 5,
    LISTINGPAGE = 10
}

export enum WALLETSTATUSSTRING {
    INACTIVE = "Inactive",
    ACTIVE = "Active", 
    TEMPLK = "Temporary Locked",
    TEMPBLK = "Temporary Blocked",
    PERMBLK = "Permanent Blocked",
    DORMANT = "Dormant",
    CMPLNCEBLK = "Compliance Blocked",
    UNKNOWN = "Unknown",
}

export interface WalletCardsStatuses {
    physicalCardStatus: string | null, 
    virtualCardStatus: string | null
}


// WEBPACK FOOTER //
// ./src/model/models/wallet/wallet-card.ts